import React from "react";

const Footer = () => {
  return (
    <div className="text-center text-white p-3 bg-secondary">
      © BOOKS - 2023
    </div>
  );
};

export default Footer;
